import moment from 'moment';

export default {
    methods: {
        emailLink(email, cssClass = 'email') {
            if (!email) {
                return '';
            }

            email = String(email).trim();

            return `<a class="${cssClass}" href="mailto:${email}" title="${email}">${email}</a>`;
        },
        /**
         * Formats amount specified in the smallest unit of the currency.
         * @param {int} amount
         * @param {int} scale
         * @returns {string}
         */
        formatAmount(amount, scale = 100) {
            return String(
                (amount / scale).toFixed(2)
            ).replace('.', ',');
        },
        formatMinutes(minutes) {
            if (minutes < 60) {
                return minutes + 'min';
            }

            let hours = Math.floor(minutes / 60);
            minutes = minutes % 60;
            let formatted = `${hours}h`;

            if (minutes > 0) {
                formatted += ` ${minutes}min`;
            }

            return formatted;
        },
        isoDateTime(timestamp, onNull = '') {
            if (timestamp instanceof Date) {
                timestamp = timestamp.getTime() / 1000;
            }

            if (null === timestamp) {
                return onNull;
            }

            return moment
                .unix(timestamp)
                .utc()
                .add(moment().utcOffset(), 'minutes')
                .format('YYYY-MM-DD');
        },
        localDateTime(timestamp, onNull = null, format = 'YYYY-MM-DD HH:mm:ss') {
            if (null === timestamp) {
                return onNull;
            }

            if (timestamp instanceof Object) {
                // See \App\Dto\DateTimeDto in API.
                timestamp = timestamp.timestamp;
            }

            if (null === timestamp) {
                return onNull;
            }

            return moment
                .unix(timestamp)
                .utc()
                .add(moment().utcOffset(), 'minutes')
                .format(format);
        },
        wwwLink(url) {
            if (!url) {
                return '';
            }

            const originalUrl = url;
            url = String(url).trim();

            if (!url.startsWith('https://') && !url.startsWith('http://')) {
                // We don't know which is better for this website - https:// or http:// so let the browser find out.
                url = '//' + url;
            }

            return `<a target="_blank" class="www" href="${url}" title="${originalUrl}">${originalUrl}</a>`;
        }
    }
}